<template>
  <oxd-dialog
    :style="{width: '90%', maxWidth: '650px'}"
    @update:show="onCancel"
  >
    <div class="gsl-hrm-modal-header">
      <oxd-text type="card-title">
        {{ $t('performance.employee_review_period') }}
      </oxd-text>
    </div>
    <oxd-divide />
    <div class="gsl-hrm-container">
      <oxd-card-table
        :headers="headers"
        :items="items"
        :clickable="false"
        class="gsl-hrm-horizontal-padding"
        row-decorator="oxd-table-decorator-card"
      />
    </div>
  </oxd-dialog>
</template>
<script>
import {OxdDialog} from '@ohrm/oxd';
export default {
  name: 'EmployeeReviewPeriodListModal',
  components: {
    'oxd-dialog': OxdDialog,
  },
  props: {
    items: {
      type: Object,
      required: true,
    },
  },
  emits: ['close'],
  data() {
    return {
      isLoading: false,
      headers: [
        {
          title: this.$t('performance.review_period_start_date'),
          name: 'reviewStartPeriod',
          slot: 'left',
          style: {flex: 1},
        },
        {
          title: this.$t('performance.review_period_end_date'),
          name: 'reviewEndPeriod',
          slot: 'right',
          style: {
            flex: 1,
            textAlign: 'right',
            justifyContent: 'flex-end',
          },
        },
      ],
    };
  },
  methods: {
    onCancel() {
      this.$emit('close', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.gsl-hrm-container {
  padding: 0.5rem 0;
  max-height: 300px;
  overflow-y: auto;
  @include oxd-scrollbar();
}
</style>
